import React, { Fragment } from 'react'
import { Container, Card, Row, Col, Button, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { LoadingComponent } from 'recupero-comunes'
import { useSelector } from 'react-redux'

const DetalleCasos = ({ data }) => {
  const loading = useSelector(
    (state) => state.consultarCasosAnalyticReducer.loading
  )

  const data_analyticBuscar = useSelector(
    (state) => state.areaBusquedaCasosReducer
  )
  const { comboTipoFecha } = data_analyticBuscar

  const handleAccionClick = async (row) => {
    if (row.eaa_var_ubicaArchivo) {        
        const link = document.createElement('a');
        link.href = row.eaa_var_ubicaArchivo;
        link.download = ''; 
        link.target = '_blank'; 
        document.body.appendChild(link);
        link.click(); 
        document.body.removeChild(link);
    } else {
        console.log("No se encontró una URL para descargar.");        
    }
  }

  const formatearFecha = (fecha) => {
    if (!fecha) return ''
    return new Date(fecha).toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  }
  
  const formatearCriterio = (criterioFecha) => {
    if (criterioFecha=='0') return 'S/C'    
    const criterioFiltrado = Object.values(comboTipoFecha)[0].find(item => item.id === parseInt(criterioFecha));
    return criterioFiltrado ? criterioFiltrado.nombre : '';
  }
    
  const obtenerColumnas = () => [
    {
      dataField: 'eaa_int_idEmision',
      text: 'ID',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'eaa_dat_fechaEstado',
      text: 'Fecha de Emisión',
      formatter: (cell) => formatearFecha(cell),
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'eaa_int_criterioFecha',
      text: 'Criterio Fecha',
      formatter: (cell) => formatearCriterio(cell),
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'eaa_dat_fechaDesde',
      text: 'Fecha Desde',
      formatter: (cell) => formatearFecha(cell),
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'eaa_dat_fechaHasta',
      text: 'Fecha Hasta',
      formatter: (cell) => formatearFecha(cell),
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'eaa_int_cntRegistros',
      text: 'Cantidad de Casos',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'glosaEstado',
      text: 'Estado de Emisión',      
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'nombre',
      text: 'Usuario',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'eaa_var_ubicaArchivo',
      text: 'Acción',
      isDummyField: true,
      formatter: (_, row) => (
        <Button
          variant='success'
          size='sm'
          onClick={() => handleAccionClick(row)}
          hidden={row.eaa_int_cntRegistros==null||row.eaa_var_ubicaArchivo==null||row.eaa_var_ubicaArchivo==""?true:false}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-file-earmark-excel'
            viewBox='0 0 16 16'
          >
            <path d='M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z' />
            <path d='M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z' />
          </svg>
        </Button>
      ),
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    }
  ]

  const paginationOptions = {
    paginationSize: 5,
    showTotal: true,
    paginationTotalRenderer: (from, to, size) => (
      <span className='ms-2'>
        Mostrando {from} a {to} de {size} resultados
      </span>
    ),
    paginationWrapperClasses: 'custom-pagination-wrapper' 
  }

  return (
    <Fragment>
      <style type='text/css'>
        {`
          .tabla-personalizada .react-bootstrap-table-pagination {
            margin-right: 0 !important;
            margin-left: 0 !important;
          }  
          
          .btn-subir {
            background-color: #00aeab;
            color: #FFFFFF;   
            height:40px;

          }
          .btn-subir:hover{
              background-color:#01cec8;
              color: #FFFFFF;              
          } 
        `}
      </style>
      <LoadingComponent show={loading} />
      <Container className='mt-4'>
        <Card>
          <Card.Header
            className='text-center'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            Detalle de Casos
          </Card.Header>
          <ToolkitProvider
            keyField='eaa_int_idEmision'
            data={data}
            columns={obtenerColumnas()}
            search
            bootstrap4
            defaultSorted={ [{ dataField: 'eaa_int_idEmision', order: 'asc' }] }
          >            
            {(props) => (
              <div>
                <Row className='mb-2'>
                  <Col className='d-grid gap-2 d-md-flex justify-content-md-end mt-2'>
                    <Form.Control
                      placeholder='Buscar en la grilla'
                      className='w-25'
                      onChange={(e) =>
                        props.searchProps.onSearch(e.target.value)
                      }
                    />
                    <Button variant='outline-info me-2' size='sm'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-arrow-clockwise'
                        viewBox='0 0 16 16'
                      >
                        <path
                          fillRule='evenodd'
                          d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
                        />
                        <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
                      </svg>
                    </Button>
                  </Col>
                </Row>
                <div className='tabla-personalizada'>
                  <BootstrapTable
                    {...props.baseProps}
                    headerWrapperClasses='table-secondary'
                    pagination={paginationFactory(paginationOptions)}
                    noDataIndication={
                      <div className='text-center'>
                        No hay registros encontrados
                      </div>
                    }
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </Card>
      </Container>
    </Fragment>
  )
}

export default DetalleCasos
